import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  strokeColor?: string
}

// Order-stage rail glyph: "ready" (Live Updates Overview tab). Geometry is the
// Sketch prototype's own (live-updates-onboarding v31, `ICON2`), traced rather
// than approximated so the rail reads as one set.
const ShoppingBag = ({ className, strokeColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
    <path d="M3 6h18" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
)

export default ShoppingBag
